export const MoldType = Object.freeze({
  Rectangle: 1,
  Round: 0,
  Silicone: 2,
});

const getMoldTypeAsString = (type) => {
  switch (type) {
    case MoldType.Round:
      return 'round';
    case MoldType.Rectangle:
      return 'rectangle';
    case MoldType.Silicone:
      return 'silicone';
    default:
      return null;
  }
};

const SIDE = Object.freeze({ Left: 'left', Right: 'right' });

export { SIDE, getMoldTypeAsString };
